import axiosInstance from './instance';

const axiosService = axiosInstance();

export const genericSearch = async (field, value, page, size) => {
    try {
        //const response = await axiosService.get(`master-data/search/dropdown?${field}=${value}`);
        const response = await axiosService.get(`master-data/search/dropdown?${field}=${value}&attributes=${field}&page=${page}&size=${size}`);
        console.log("data->", response);
        const result = response.data.data.map((course) => {
            const value = course.name || course.university;
            return {
                key: value,
                value: value
            }
        })
        return result;
    } catch (error) {
        return error;
    }
}

export const getMasterDataBasedOnSpecificField = async (field, value, getField, page, size) => {
    try {
        const response = await axiosService.get(`master-data/search/dropdown?${field}=${value}&attributes=${getField}&page=${page}&size=${size}`);
        console.log("data->", response);
        const result = response.data.data.map((course) => {
            const value = course.name || course.university;
            return {
                key: value,
                value: value
            }
        })
        return result;
    } catch (error) {
        return error;
    }
}
export const genericSearchBasedOnTwoFields = async (field1, value1, field2, value2, getField, page, size) => {
    try {
        const response = await axiosService.get(`master-data/search/dropdown?${field1}=${value1}&${field2}=${value2}&attributes=${getField}&page=${page}&size=${size}`);
        console.log("data->", response);
        const result = response.data.data.map((course) => {
            const value = course.name || course.university;
            return {
                key: value,
                value: value
            }
        })
        return result;
    } catch (error) {
        return error;
    }
}








export const getcountries = async () => {
    const countries = await axiosService.get(`master-data/get-all-country-names`);
    const result = countries.data.map((country) => {
        const value = country;
        return {
            key: value,
            value: value
        }
    })
    return result;
};

export const getuniversities = async (country) => {
    const universities = await axiosService.get(`master-data/search/get-university/${country}`);
    const result = universities.data.map((university) => {
        const value = university;
        return {
            key: value,
            value: value
        }
    })
    return result;
};

export const getCoursesBasedOnUniversities = async (university) => {
    const courses = await axiosService.get(`master-data/search/get-course/${university}`);
    const result = courses.data.map((course) => {
        const value = course;
        return {
            key: value,
            value: value
        }
    })
    return result;
};


export const getCourses = async (universityname, countryname) => {
    try {
        const response = await axiosService.get(`master-data/search/get-course/${universityname}/${countryname}`);
        const result = response.data.map((course) => {
            const value = course;
            return {
                key: value,
                value: value
            }
        })
        return result;
    } catch (error) {
        return error;
    }
}

export const getIntakeBasedOnCourses = async (coursename) => {
    try {
        const intakes = await axiosService.get(`master-data/search/get-intakes/${coursename}`);
        const result = intakes.data.map((intake) => {
            const value = intake;
            return {
                key: value,
                value: value
            }
        })
        return result;
    } catch (error) {
        return error;
    }
}

export const getIntakes = async (coursename, universityname, countryname) => {
    try {
        const response = await axiosService.get(`master-data/search/get-intakes/${coursename}/${universityname}/${countryname}`);
        console.log("Responce Data ==>>", response.data);
        const result = response.data.map(value => {

            const intack = value.split(', ')
            const finaldata = intack.map((data) => {
                const value = data;
                return {
                    key: value,
                    value: value
                }
            })

            return finaldata;
        })
        return result;
    } catch (error) {
        return error;
    }
}



